export default __webpack_public_path__ + "static/media/product_3.1186c4d8.webp";